import InputNoRowWithLabelAndValidation from './InputNoRowWithLabelAndValidation'

export default InputNoRowWithLabelAndValidation
